import styled from 'styled-components';

export const PropertiesTableContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;

  thead th {
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 1;
  }
`;
